import wpdmIcons from "../../libs/icons";
import LinkTemplates from "../../libs/link-templates";
import Columns from "../../libs/columns";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';

const {InspectorControls} = wp.editor;
const {TextControl, TextareaControl, SelectControl, ServerSideRender, Modal, Button, PanelBody} = wp.components;
const {registerBlockType} = wp.blocks;
const {withState} = wp.compose;
const {__} = wp.i18n;
const animatedComponents = makeAnimated();

registerBlockType('download-manager/category', {
    title: 'Categories',

    description: 'Download Manager Category',

    keywords: [
        __('download manager digital ecommerce store product sell'),
        __('file manager'),
        __('product category categories')
    ],

    icon: wpdmIcons.catIcon(),

    category: 'wpdm-blocks',

    attributes: {
        cats: {
            type: 'string',
            default: ""
        },
        title: {
            type: 'string',
            default: ""
        },
        desc: {
            type: 'string',
            default: ""
        },
        items_per_page: {
            type: 'string',
            default: "10"
        },
        toolbar: {
            type: 'string',
            default: '1'
        },
        paging: {
            type: 'string',
            default: "1"
        },
        cols: {
            type: 'string',
            default: "1"
        },
        colspad: {
            type: 'string',
            default: "1"
        },
        colsphone: {
            type: 'string',
            default: "1"
        },
        orderby: {
            type: 'string',
            default: ""
        },
        order: {
            type: 'string',
            default: ""
        },
        async: {
            type: 'string',
            default: "1"
        },
        template: {
            type: 'string',
            default: 'link-template-panel'
        },
        className: {
            type: 'string',
            default: ''
        }
    },

    edit({attributes, className, setAttributes}) {


        function onChangeTemplate(newTemplate) {
            setAttributes({template: newTemplate});
        }

        function onSelectCategory(categories) {
            console.log(categories);
            var selected_cats = [];
            jQuery.each(categories, function (index, category) {
                selected_cats.push(category.value);
            });
            console.log(selected_cats.join(','));
            setAttributes({cats: selected_cats.join(',')});

        }

        function selectedCats(cats) {
            var selected_cats = [];
            cats = cats.split(',');
            jQuery.each(wpdm_categories, function (index, category) {
                if (cats.indexOf(category.value) !== -1) {
                    selected_cats.push(category);
                }
            });
            return selected_cats;
        }

        function onChangeCols(cols) {
            if (cols.cols !== undefined) setAttributes({cols: cols.cols});
            if (cols.colspad !== undefined) setAttributes({colspad: cols.colspad});
            if (cols.colsphone !== undefined) setAttributes({colsphone: cols.colsphone});
            console.log(cols);
        }

        console.log(attributes);

        return ([
            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>
                        <div className="form-group">
                            <label>Include Categories:</label>
                            <Select
                                id={"categories"}
                                name={"categories"}
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={selectedCats(attributes.cats)}
                                isMulti
                                options={wpdm_categories}
                                onChange={(categories) => onSelectCategory(categories)}
                            />
                        </div>
                        <div className="form-group">
                            <SelectControl
                                label={"Toolbar:"}
                                value={attributes.toolbar}
                                class={"form-control wpdm-custom-select"}
                                options={[{label: 'Extended Toolbar', value: 1}, {
                                    label: 'Compact Toolbar',
                                    value: 'skinny'
                                }, {label: "Hide Toolbar", value: 0}]}
                                onChange={(toolbar) => setAttributes({toolbar: toolbar})}
                            />
                        </div>
                        <div className="form-group">
                            <TextControl
                                label={"Title:"}
                                value={attributes.title}
                                onChange={(text) => setAttributes({title: text})}
                            />
                        </div>
                        <div className="form-group">
                            <TextareaControl
                                label={"Description:"}
                                value={attributes.desc}
                                onChange={(text) => setAttributes({desc: text})}
                            />
                        </div>

                        <div className="form-group">
                            <TextControl
                                label={"Items Par Page:"}
                                type={"number"}
                                value={attributes.items_per_page}
                                onChange={(items_per_page) => setAttributes({items_per_page: items_per_page})}
                            />
                        </div>


                        <LinkTemplates
                            label={"Link Template:"}
                            value={attributes.template}
                            onChange={onChangeTemplate}
                        />
                        <div className="form-group">
                            <SelectControl
                                label={"Pagination:"}
                                value={attributes.paging}
                                class={"form-control wpdm-custom-select"}
                                options={[{label: 'Show', value: 1}, {label: "Hide", value: 0}]}
                                onChange={(paging) => setAttributes({paging: paging})}
                            />
                        </div>
                        <div className="form-group">
                            <Columns label={"Columns:"}
                                     cols={attributes.cols}
                                     colspad={attributes.colspad}
                                     colsphone={attributes.colsphone}
                                     onChange={onChangeCols}
                            />

                        </div>
                        <div className="form-group">
                            <SelectControl
                                label={"Asynchronous Request:"}
                                value={attributes.async}
                                class={"form-control wpdm-custom-select"}
                                options={[{label: 'Enabled', value: 1}, {label: "Disabled", value: 0}]}
                                onChange={(async) => setAttributes({async: async})}
                            />
                        </div>
                    </PanelBody>
                </div>
            </InspectorControls>,
            <ServerSideRender
                block={"download-manager/category"}
                attributes={attributes}
            />
        ]);

    },
    save() {
        return null;
    }
});
